<div class="loading">
    <div class="items">
        <div style="height: 80px;margin: auto;justify-content: center;display: flex;">
            <img height="100%" src="./assets/Img/logodelfinapp.png">
        </div>
        <div style="display: flex;justify-content: center;align-items: center;gap: 15px;">
            <div style="color: #ffffff;font-size: 12px;font-weight: 400;">{{data.message}}</div>
            <div><i class="pi pi-spin pi-spinner-dotted" style="font-size: 1.6rem;color: #ffffff;"></i></div>
        </div>
    </div>
</div>